"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.BOTTOM_MENU_LINKS = exports.TOP_MENU_LINKS = exports.MENU_LINK = exports.EMPTY_MENU_LINK_ICON = exports.LOGO = exports.ADMIN_TOGGLE = exports.LOGO_CONTAINER = void 0;

var _cxs,
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs2 = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var LOGO_PADDING = "23px",
    ADMIN_TOGGLE_WIDTH = "25px",
    ICON_CONTAINER = "> .icon-container",
    IMAGE = "> .image",
    LOGO_CONTAINER = (0, _cxs2["default"])({
  boxSizing: "border-box",
  display: "flex",
  justifyContent: "space-between",
  overflow: "hidden",
  paddingLeft: "23px",
  paddingRight: "23px"
});
exports.LOGO_CONTAINER = LOGO_CONTAINER;
var ADMIN_TOGGLE = (0, _cxs2["default"])({
  padding: 0,
  background: "none",
  border: 0,
  cursor: "pointer",
  width: ADMIN_TOGGLE_WIDTH
});
exports.ADMIN_TOGGLE = ADMIN_TOGGLE;
var LOGO = (0, _cxs2["default"])((_cxs = {
  padding: 0,
  background: "none",
  border: 0,
  cursor: "pointer"
}, (0, _defineProperty2["default"])(_cxs, ICON_CONTAINER, {
  display: "flex",
  justifyContent: "center"
}), (0, _defineProperty2["default"])(_cxs, IMAGE, {
  cursor: "pointer",
  borderRadius: "4px",
  overflow: "hidden"
}), (0, _defineProperty2["default"])(_cxs, " > .text", {
  color: "inherit"
}), _cxs));
exports.LOGO = LOGO;
var EMPTY_MENU_LINK_ICON = (0, _cxs2["default"])({
  width: "25px",
  height: "25px"
});
exports.EMPTY_MENU_LINK_ICON = EMPTY_MENU_LINK_ICON;

var MENU_LINK_HOVER = function MENU_LINK_HOVER(a) {
  var b = a.selected,
      c = a.linkHoverColor;
  return b ? {} : {
    ":hover": {
      background: c ? _vars.FLATTENED_COLOURS[c] : _vars.COLOURS.grey.athens.parthenon
    }
  };
},
    MENU_LINK = function MENU_LINK(a) {
  var b,
      c = a.selected,
      d = a.rounded,
      e = a.linkColour,
      f = a.linkHoverColor,
      g = a.linkSelectedColor;
  return (0, _cxs2["default"])(_objectSpread((b = {
    background: c ? g && _vars.FLATTENED_COLOURS[g] || _vars.COLOURS.grey.sterling : "none",
    border: 0,
    borderRadius: d ? "6px" : 0,
    display: "flex",
    width: "100%",
    fontSize: "15px",
    cursor: "pointer",
    minHeight: "50px",
    paddingLeft: "30px",
    paddingRight: "30px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    alignItems: "center"
  }, (0, _defineProperty2["default"])(b, ICON_CONTAINER, {
    display: "flex",
    justifyContent: "center"
  }), (0, _defineProperty2["default"])(b, "> .text", {
    marginLeft: "30px",
    color: e ? _vars.FLATTENED_COLOURS[e] : void 0
  }), b), MENU_LINK_HOVER({
    selected: c,
    linkHoverColor: f
  })));
};

exports.MENU_LINK = MENU_LINK;
var TOP_MENU_LINKS = (0, _cxs2["default"])({
  display: "flex",
  flex: 1,
  overflowY: "auto",
  flexDirection: "column",
  marginBottom: "35px"
});
exports.TOP_MENU_LINKS = TOP_MENU_LINKS;
var BOTTOM_MENU_LINKS = (0, _cxs2["default"])({});
exports.BOTTOM_MENU_LINKS = BOTTOM_MENU_LINKS;